import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the per-leg Driver field gate.
 *
 * The driver cell in LegsGrid is wrapped in a `leg-driver-field` PermissionsContainer
 * (see LegsGrid.tsx). Edit access on this component is what makes a user a
 * *dispatcher* for our purposes — it's the capability to assign/clear drivers.
 */
export const LEG_DRIVER_FIELD_COMPONENT_ID = 'leg-driver-field';

/**
 * Whether the current user may edit the per-leg Driver field, i.e. holds
 * dispatcher-level access.
 *
 * Resolved from the admin-configured component permission crossed with the
 * user's Azure AD groups. `leg-driver-field` ships **defaultDisabled**, so
 * un-configured groups resolve to level 1 (View — read-only) rather than edit;
 * admins grant Edit to the dispatcher groups. This MUST match the fallback used
 * for `driverAccess` in OrderFormContext so the field-edit gate and this prompt
 * gate never diverge.
 *
 * Sole gate for the drop→clear-appt-dates prompt: anyone who can edit the
 * driver field can remove a driver assignment themselves without coordinating
 * with a dispatcher, so the prompt fires only for users WITHOUT this access.
 */
export const useCanEditDriverField = (): boolean =>
  useResolvedAccessLevel(LEG_DRIVER_FIELD_COMPONENT_ID, false, true) >= 2;
